/**
 * Terms of Service Page - /terms
 * Public route, no auth required.
 *
 * The canonical Terms live on the marketing site (single source of truth).
 * This route forwards there to prevent the drift that came from maintaining a
 * second hardcoded copy. See CanonicalLegalRedirect.
 */
import { createFileRoute } from '@tanstack/react-router';
import { CanonicalLegalRedirect } from '@/components/legal/CanonicalLegalRedirect';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

function TermsPage() {
  return (
    <CanonicalLegalRedirect
      doc="terms"
      titleKey="legalRedirect.termsTitle"
      titleFallback="Terms of Service"
    />
  );
}
